export var KonturColors = {
    red0: '#f03b36',
    red10: '#ffddd6',
    red20: '#ffc8bf',
    red30: '#ffb2a9',
    red40: '#ff9d92',
    redLightBasic50: '#ff887b',
    redBasic60: '#ff5a49',
    red70: '#ee5042',
    red80: '#dd473b',
    red90: '#cb3d35',
    red100: '#ba342e',
    red110: '#a92a27',
    orange0: '#fc7630',
    orange10: '#ffe0c3',
    orange20: '#ffd1a0',
    orange30: '#ffc17d',
    orange40: '#ffb259',
    orangeLightBasic50: '#ffa236',
    orangeBasic60: '#ff8227',
    orange70: '#ea7324',
    orange80: '#d46421',
    orange90: '#bf561e',
    orange100: '#a9471b',
    orange110: '#943817',
    yellow0: '#feca42',
    yellow10: '#ffeec2',
    yellow20: '#fde1a1',
    yellow30: '#fdd481',
    yellow40: '#fcc660',
    yellowLightBasic50: '#fcb73e',
    yellowBasic60: '#fda70c',
    yellow70: '#f69912',
    yellow80: '#ef8b17',
    yellow90: '#e77e1b',
    yellow100: '#de711e',
    yellow110: '#d46421',
    greenLite0: '#64b419',
    greenLite10: '#d7f8ae',
    greenLite20: '#c8f18e',
    greenLite30: '#b9e96e',
    greenLite40: '#aae24d',
    greenLiteLightBasic50: '#9bdb2d',
    greenLiteBasic60: '#78bf2b',
    greenLite70: '#6cad26',
    greenLite80: '#5f9c20',
    greenLite90: '#538a1b',
    greenLite100: '#477916',
    greenLite110: '#3a6710',
    green0: '#26ad50',
    green10: '#c7f9cc',
    green20: '#a7eeb3',
    green30: '#87e39a',
    green40: '#67d881',
    greenLightBasic50: '#46cd68',
    greenBasic60: '#26ad50',
    green70: '#23a14a',
    green80: '#209644',
    green90: '#1c8a3f',
    green100: '#197f39',
    green110: '#167333',
    greenMint0: '#00bea2',
    greenMint10: '#c6f5ec',
    greenMint20: '#a8eee2',
    greenMint30: '#8be7d8',
    greenMint40: '#6ddfcd',
    greenMintLightBasic50: '#4fd8c3',
    greenMintBasic60: '#00c5a8',
    greenMint70: '#00b59a',
    greenMint80: '#00a58d',
    greenMint90: '#00957f',
    greenMint100: '#008571',
    greenMint110: '#007564',
    blue0: '#2291ff',
    blue10: '#cdedff',
    blue20: '#aeddff',
    blue30: '#8fcdff',
    blue40: '#70bdff',
    blueLightBasic50: '#51adff',
    blueBasic60: '#2291ff',
    blue70: '#1f87ef',
    blue80: '#1c7edf',
    blue90: '#1874cf',
    blue100: '#156abe',
    blue110: '#1261ae',
    blueDark0: '#366af3',
    blueDark10: '#dde6ff',
    blueDark20: '#becfff',
    blueDark30: '#9fb8ff',
    blueDark40: '#80a1ff',
    blueDarkLightBasic50: '#618aff',
    blueDarkBasic60: '#366af3',
    blueDark70: '#3365e8',
    blueDark80: '#3060dc',
    blueDark90: '#2e5ad1',
    blueDark100: '#2b55c5',
    blueDark110: '#2850ba',
    purple0: '#b750d1',
    purple10: '#f7d7ff',
    purple20: '#eabdf6',
    purple30: '#dea3ec',
    purple40: '#d189e3',
    purpleLightBasic50: '#c56fda',
    purpleBasic60: '#b750d1',
    purple70: '#aa49c3',
    purple80: '#9e43b5',
    purple90: '#913ca6',
    purple100: '#843698',
    purple110: '#782f8a',
    grayscaleText: '#222',
    grayscaleSecondaryText: '#757575',
    grayscaleDisabledText: '#adadad',
    grayscaleDarkBackground: '#d6d6d6',
    grayscaleBackground: '#e6e6e6',
    grayscaleLightBackground: '#f0f0f0',
    grayscaleWhite: '#fff',
    grayscale865Text: 'rgba(0, 0, 0, 0.865)',
    grayscale54SecondaryText: 'rgba(0, 0, 0, 0.54)',
    grayscale32DisabledText: 'rgba(0, 0, 0, 0.32)',
    grayscale16DarkBackground: 'rgba(0, 0, 0, 0.16)',
    grayscale10Background: 'rgba(0, 0, 0, 0.1)',
    grayscale06LightBackground: 'rgba(0, 0, 0, 0.06)',
};
